import { PortfolioReturnsPncsElement } from 'communication/types/portfolioReturns/PortfolioReturnsDataElement';

export interface PortfolioReturnsDataPortfolioValues {
    previousNightCloseDate: number;
    /*
     * Portfolio values corresponding to p[0-5] values in main timeseries array,
     * calculated (on the server) using previous close prices as of the date given in PNCS[d]
     */
    values: number[];
}

export function mapToPortfolioReturnsDataPortfolioValuesItemFromElement(
    from: PortfolioReturnsPncsElement
): PortfolioReturnsDataPortfolioValues {
    return {
        previousNightCloseDate: from.t,
        values: from.v,
    };
}
